/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface OrdersItemsDetailDTO {
  codigoPedidoV?: string;
  costPrice?: number;
  defaultImageURL?: string;
  externalId?: number;
  externalStoreUrl?: string;
  genero?: string;
  hasDetailedInfo?: boolean;
  inStockAcquisition?: number;
  inStockFidelization?: number;
  inStockInfluencerB4A?: number;
  inStockReserveMarketing?: number;
  internalEAN?: string;
  millenniumSKU?: string;
  ncm?: string;
  ordersItemsId?: number;
  pedidoV?: string;
  productEAN?: string;
  productName?: string;
  productQuantity?: number;
  productVariantName?: string;
  variantSummary?: string;
}
